import { IconProps } from "../../utils/global-types/global-types";

const VerbamessengerIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <g clipPath="url(#clip0_28273_16819)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.52114 2.45209C8.58641 1.51616 7.34324 1.00047 6.01865 1C3.28923 1 1.06789 3.22111 1.06694 5.95124C1.06646 6.82401 1.29463 7.67588 1.72793 8.42663L1.02539 10.9927L3.65035 10.3042C4.37354 10.6988 5.1879 10.9065 6.01652 10.9068H6.01865C8.7476 10.9068 10.9692 8.68541 10.9701 5.95528C10.9706 4.63213 10.4561 3.38825 9.52114 2.45232V2.45209ZM6.01865 10.0706H6.01699C5.2786 10.0703 4.55423 9.87182 3.92221 9.49693L3.77192 9.40768L2.21418 9.81627L2.6299 8.29746L2.53208 8.14171C2.12015 7.48644 1.90243 6.72903 1.90291 5.95149C1.90386 3.68242 3.75007 1.83621 6.02034 1.83621C7.11959 1.83668 8.15288 2.26523 8.92995 3.04327C9.70705 3.82108 10.1346 4.8553 10.1342 5.95481C10.1332 8.22412 8.28702 10.0703 6.01865 10.0703V10.0706ZM8.27608 6.98832C8.15238 6.92635 7.54412 6.62718 7.43061 6.58588C7.31713 6.54456 7.23476 6.52392 7.15235 6.64785C7.06998 6.7718 6.83279 7.05053 6.76061 7.1329C6.68843 7.21553 6.61625 7.22575 6.49255 7.16376C6.36887 7.1018 5.97023 6.97122 5.49752 6.54978C5.12976 6.22166 4.88139 5.81663 4.80923 5.69268C4.73705 5.56876 4.80163 5.5018 4.86335 5.4403C4.9189 5.38475 4.98705 5.29572 5.04901 5.22354C5.111 5.15135 5.13141 5.09961 5.17271 5.01721C5.21404 4.93459 5.19337 4.86243 5.16252 4.80044C5.13163 4.73848 4.88426 4.12948 4.78097 3.88185C4.68053 3.64063 4.57846 3.6734 4.50271 3.66936C4.43053 3.6658 4.34815 3.66509 4.26553 3.66509C4.1829 3.66509 4.04898 3.69595 3.9355 3.81989C3.82202 3.94381 3.50244 4.2432 3.50244 4.85196C3.50244 5.46072 3.94572 6.04931 4.00768 6.13193C4.06964 6.21456 4.8802 7.46412 6.12122 8.00022C6.41636 8.12771 6.64688 8.20392 6.82661 8.26091C7.12293 8.35517 7.39263 8.34188 7.60583 8.31006C7.84351 8.27445 8.33782 8.01066 8.44086 7.72171C8.5439 7.43276 8.5439 7.18489 8.51304 7.13337C8.48219 7.08185 8.39956 7.05075 8.27586 6.98879L8.27608 6.98832Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_28273_16819">
          <rect
            width="9.94475"
            height="10"
            fill="white"
            transform="translate(1.02539 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VerbamessengerIcon;
